import { generatePath, Navigate, NavigateProps } from 'react-router-dom';

import { CheckParamReq, ExtractParams } from '../types';

export interface TypedNavigateProps<TPath extends string> extends Omit<NavigateProps, 'to'> {
  to: TPath;
  params: ExtractParams<TPath>;
  queryParams?: string | Record<string, string>;
}

export function TypedNavigate<TPath extends string>({
  to,
  params,
  queryParams,
  ...rest
}: CheckParamReq<TypedNavigateProps<TPath>>) {
  return (
    <Navigate
      {...rest}
      to={{
        pathname: generatePath(to, params),
        search: typeof queryParams === 'string' ? queryParams : `?${new URLSearchParams(queryParams).toString()}`,
      }}
    />
  );
}
